import Head from 'next/head';
import {ReactElement} from 'react';
import {STRIPE_ENV, useStripeEnv} from 'mkt-ssr/lib/env';

type FaviconIcons = {
  icon: string;
  shortcutIcon: string;
  appleTouchIcon: string;
  svgIcon: string;
};

const FAVICON_URLS: {[K in STRIPE_ENV]: FaviconIcons} = {
  [STRIPE_ENV.DEV]: {
    icon: 'https://images.stripeassets.com/fzn2n1nzq965/4zDUITa7Do2HwzRZI408lv/44ec5c6a653dc7d62822eced90f630db/devbox-favicon.png?w=96&h=96',
    shortcutIcon:
      'https://assets.stripeassets.com/fzn2n1nzq965/45ru7FZbwWM3f7DGvt3Hl9/afc67e874e62ad8c71654b328c7609a7/devbox-favicon.ico',
    appleTouchIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/4zDUITa7Do2HwzRZI408lv/44ec5c6a653dc7d62822eced90f630db/devbox-favicon.png?w=180&h=180',
    svgIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/1aaNAgRXtmGGKzlKly6buq/20148d25d1fbe00e4391c86b62e5c248/devbox-favicon.svg',
  },
  [STRIPE_ENV.QA]: {
    icon: 'https://images.stripeassets.com/fzn2n1nzq965/7tFw8CN157pgUGXW9DLot7/ff4fc85fa53ec9bb41320ceec375f27c/qa-favicon.png?w=96&h=96',
    shortcutIcon:
      'https://assets.stripeassets.com/fzn2n1nzq965/40iz26TZP5x6AYEJ1yg5JW/b63d1299f809e404492f1f1fd2fe2fe2/qa-favicon.ico',
    appleTouchIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/7tFw8CN157pgUGXW9DLot7/ff4fc85fa53ec9bb41320ceec375f27c/qa-favicon.png?w=180&h=180',
    svgIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/2MURebKVz4ZyCUnuDeQ6rt/9cec8aa63e17a500b6818b28691ee95c/qa-favicon.svg',
  },
  [STRIPE_ENV.PREPROD]: {
    icon: 'https://images.stripeassets.com/fzn2n1nzq965/4vVgZi0ZMoEzOhkcv7EVwK/8cce6fdcf2733b2ec8e99548908847ed/favicon.png?w=96&h=96',
    shortcutIcon:
      'https://assets.stripeassets.com/fzn2n1nzq965/nu0iR4KqmkdJ52fgRts09/c3a10df318e7ffb1f516073daadea625/favicon.ico',
    appleTouchIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/4vVgZi0ZMoEzOhkcv7EVwK/8cce6fdcf2733b2ec8e99548908847ed/favicon.png?w=180&h=180',
    svgIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/1hgcBNd12BfT9VLgbId7By/01d91920114b124fb4cf6d448f9f06eb/favicon.svg',
  },
  [STRIPE_ENV.PROD]: {
    icon: 'https://images.stripeassets.com/fzn2n1nzq965/4vVgZi0ZMoEzOhkcv7EVwK/8cce6fdcf2733b2ec8e99548908847ed/favicon.png?w=96&h=96',
    shortcutIcon:
      'https://assets.stripeassets.com/fzn2n1nzq965/nu0iR4KqmkdJ52fgRts09/c3a10df318e7ffb1f516073daadea625/favicon.ico',
    appleTouchIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/4vVgZi0ZMoEzOhkcv7EVwK/8cce6fdcf2733b2ec8e99548908847ed/favicon.png?w=180&h=180',
    svgIcon:
      'https://images.stripeassets.com/fzn2n1nzq965/1hgcBNd12BfT9VLgbId7By/01d91920114b124fb4cf6d448f9f06eb/favicon.svg',
  },
};

/**
 * Renders the various favicons needed for stripe.com
 */
export const Favicons = (): ReactElement => {
  const environment = useStripeEnv();

  return (
    <Head>
      <link
        rel="icon"
        type="image/svg+xml"
        href={FAVICON_URLS[environment].svgIcon}
      />
      <link
        rel="icon"
        type="image/png"
        href={FAVICON_URLS[environment].icon}
        sizes="96x96"
      />
      <link rel="shortcut icon" href={FAVICON_URLS[environment].shortcutIcon} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={FAVICON_URLS[environment].appleTouchIcon}
      />
    </Head>
  );
};
